<template>
    <div v-if="loading" class="pt-3">            
        <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
    </div>        
    <div v-else-if="documents.length" class="table-responsive px-2">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th></th>
                    <th><div>Claim</div><div>Number</div></th>
                    <th>Patient</th>
                    <th v-if="hasDescription">Description</th>
                    <th v-if="hasClientName">Client</th>
                    <th v-if="hasProviderName">Provider</th>
                    <th>Payer</th>
                    <th v-if="hasAmount" class="text-right">Amount</th>
                    <th>Submitted</th>
                    <th class="text-right"><div>Days</div><div>Overdue</div></th>
                    <th></th>                 
                </tr>
            </thead>
            <tbody>
                <tr v-for="document in documents" :key="'overdue-documents-list-' + document.document_id">
                    <td class="fit">{{ document.document_id }}<i v-if="document.attention" class="fas fa-exclamation-triangle text-warning fa-lg" :title="document.attention_message"></i></td>
                    <td><a :href="'/claims/' + document.claim_id">{{ document.claim_number }}</a></td>
                    <td><a :href="'/claims/' + document.claim_id">{{ document.patient_name }}</a></td>
                    <td v-if="hasDescription">{{ document.description }}</td>
                    <td v-if="hasClientName">{{ document.client_name }}</td>
                    <td v-if="hasProviderName">{{ document.provider_name }}</td>
                    <td>{{ document.payer_name }}</td>
                    <td v-if="hasAmount" class="text-right">{{ document.amount | currency }}</td>
                    <td>{{ document.submitted_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                    <td class="text-right">{{ document.days_overdue }}</td> 
                    <td>
                        <button v-if="!readonly" type="button" class="btn btn-link p-0" :title="title === 'active' ? 'Mark Inactive' : 'Mark Active'" @click="changeState(document.document_id)">
                            <i v-if="title === 'active'" class="fas fa-eye-slash fa-lg"></i>
                            <i v-else class="fas fa-eye fa-lg"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table> 
    </div>
    <div v-else>
        <h2 class="text-muted text-center">No {{ title }} documents.</h2>
    </div>    
</template>

<script>
export default {
    props: {
        title: String,
        documents: Array,
        readonly: Boolean,
        loading: Boolean
    },
    computed: {
        hasDescription: function () {
            return this.documents.length && this.documents[0].hasOwnProperty('description');
        },
        hasClientName: function () {
            return this.documents.length && this.documents[0].hasOwnProperty('client_name');
        },
        hasProviderName: function () {
            return this.documents.length && this.documents[0].hasOwnProperty('provider_name');
        },        
        hasAmount: function () {
            return this.documents.length && this.documents[0].hasOwnProperty('amount');
        }
    },    
    methods: {
        changeState: function (id) {
            axios.patch('/ajax/provider/documents/' + id + '/active-state')
                .then(response => {
                    this.$emit('refresh');
                })
                .catch(error => {

                });
        }
    }
}
</script>

<style scoped>
    .fa-exclamation-triangle.text-warning {
        background:linear-gradient(#555,#555) center bottom/20% 84% no-repeat;
    }   
</style>